import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../components/dashboard/dashboardHeader";
import { CompanyAiMailboxesSection } from "../../../components/dashboard/microsoft/CompanyAiMailboxesSection";

/**
 * Admin: delte firmainnbokser (Microsoft 365) for AI / saker — kobling, innboks og behandlingsinnstillinger.
 * Firmamail øverst (company_inbox) er skjult inntil videre; bruk delte adresser.
 */
export function CompanyMicrosoftOutlook() {
  const { t } = useTranslation();

  return (
    <DashboardHeader
      title={t("microsoft.ai_mailboxes.admin_page_title")}
      subtitle={t("microsoft.ai_mailboxes.admin_page_subtitle")}
      meta={[]}
      actions={[]}
    >
      <div className="mx-auto mt-8 max-w-3xl px-4 pb-16 sm:px-6 lg:max-w-4xl">
        <CompanyAiMailboxesSection />
      </div>
    </DashboardHeader>
  );
}
